import {Cards} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER} from '/enum/competency.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {
  CoachesTeamSummaryCardProps,
  SummaryItem,
} from './CoachesTeamSummaryCard.types';

export const useCoachesTeamSummaryCard = ({
  currentUserCompetency,
  metrics,
}: CoachesTeamSummaryCardProps) => {
  const {tt} = useTranslation('filterComingSoon');

  const isBusinessCoach = currentUserCompetency === BUSINESS_COACH;
  const isBusinessLeader = currentUserCompetency === BUSINESS_LEADER;

  const firstItems: SummaryItem[] = [
    {
      isFirstItem: true,
      titleTestID: Cards.cardNewFrontlineCoachesTitle,
      text: tt('new.frontline', 'New Frontline Coaches'),
      testID: Cards.cardNewFrontlineCoachesValue,
      value: metrics?.newFrontline,
    },
    {
      titleTestID: Cards.cardNewGen0CoachesTitle,
      text: tt('new.generation', 'New Generation 0 Coaches'),
      testID: Cards.cardNewGen0CoachesValue,
      value: metrics?.newGen0,
    },
    {
      isBusinessLeaderMetric: true,
      titleTestID: Cards.cardNewOrganizationCoachesTitle,
      text: tt('new.org', 'New Organization Coaches'),
      testID: Cards.cardNewOrganizationCoachesValue,
      value: metrics?.newOrganization,
    },
  ];

  const secondItems: SummaryItem[] = [
    {
      titleTestID: Cards.cardSeniorCoachTeamsTitle,
      text: tt('total.coaches', 'Senior Coach Teams'),
      testID: Cards.cardSeniorCoachTeamsValue,
      value: metrics?.teamsSeniorCoach,
    },
    {
      titleTestID: Cards.cardExecutiveDirectorTeamsTitle,
      text: tt('total.directors', 'Executive Director Teams'),
      testID: Cards.cardExecutiveDirectorTeamsValue,
      value: metrics?.teamsExecutiveDirector,
    },
    {
      isBusinessLeader: true,
      titleTestID: Cards.cardFIBCTeamsTitle,
      text: tt('total.fibc', 'FIBC Teams'),
      testID: Cards.cardFIBCTeamsValue,
      value: metrics?.teamsFibc,
    },
  ];
  return {isBusinessCoach, isBusinessLeader, firstItems, secondItems, tt};
};
